<section class="testimonial-section">
    <div class="container">
        <div class="row justify-content-center justify-content-lg-start">
            <div class="col-lg-12 col-md-12 text-center pt-5">
                <h1 class="titleSecc5 mt-5">
                    ¡Sea parte de la comunidad Angus!
                </h1>
                <h3 class="titleSecc5 mt-4 mb-4">
                    ¡Sea nuestro socio estratégico! participando como:
                </h3>
                <p class="titleSecc5 mt-5 mb-5"><i class="far fa-check"></i> &nbsp;Criador certificado&nbsp;&nbsp;&nbsp;<i class="far fa-check"></i> &nbsp;Engordador certificado&nbsp;&nbsp;&nbsp;<i class="far fa-check"></i> &nbsp;Comercializador&nbsp;&nbsp;&nbsp;<i class="far fa-check"></i> &nbsp;Establecimiento de sacrificio certificado</p>
                <a routerLink="/contact" class="main-btn main-btn-4 mt-2">Quiero ser socio</a>
            </div>
        </div>
    </div>
    <section id="Noticias"></section>
</section>